import { defineAiSystem } from '@evo-flywheel/contracts/base';
/**
 * Sistema AI — the AI registry record the AI Act tables evaluate (reference/rules/aiact/).
 * coreBOS module evSistemaAI, the same module ai-portal uses: on a customer's one coreBOS both
 * kits read and write the same record (governance ADR-031). Read-only usage projections and the
 * approval workflow relations stay ai-portal's.
 */
export const aiSystemDescriptor = defineAiSystem({
    table: 'cmp_ai_system',
    emits: ['ai_system.created', 'ai_system.updated'],
    ui: { mode: 'generated', icon: 'RobotOutlined', navGroup: 'AI Act', navOrder: 1 },
});
